// src/api/programs/endpoints.ts
export const PROGRAMS_ENDPOINTS = {
  BASE: "/v1/programs",
  DETAIL: (id: string) => `/v1/programs/${id}`,
} as const;
